import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { FilterIcon } from '@heroicons/vue/solid';

import { UiButton, UiMultiselect, UiRightPanel } from '@/components';
import type { AuraProcessingCostsFilters } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraProcessingCostsFilters',
  props: {
    modelValue: { type: Object, required: true },
    users: { type: Array, required: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const emit = __emit;
const { t } = useI18n();

const filtersOpened = ref(false);
const typeOptions = computed(() => [
    { label: t('aura.processingCosts.processingTypes.summary'), value: 'summary' },
    { label: t('aura.processingCosts.processingTypes.chunking'), value: 'chunking' },
    { label: t('aura.processingCosts.processingTypes.embedding'), value: 'embedding' },
    { label: t('aura.processingCosts.processingTypes.indexing'), value: 'indexing' },
    {
        label: t('aura.processingCosts.processingTypes.insight_extraction'),
        value: 'insight_extraction',
    },
    { label: t('aura.processingCosts.processingTypes.rag_engine'), value: 'rag_engine' },
    { label: t('aura.processingCosts.processingTypes.sql_engine'), value: 'sql_engine' },
    {
        label: t('aura.processingCosts.processingTypes.free_sql_agent'),
        value: 'free_sql_agent',
    },
    {
        label: t('aura.processingCosts.processingTypes.free_sql_narration'),
        value: 'free_sql_narration',
    },
    {
        label: t('aura.processingCosts.processingTypes.answer_generation'),
        value: 'answer_generation',
    },
    {
        label: t('aura.processingCosts.processingTypes.answer_agent_reasoning'),
        value: 'answer_agent_reasoning',
    },
    { label: t('aura.processingCosts.processingTypes.classify'), value: 'classify' },
    {
        label: t('aura.processingCosts.processingTypes.memory_summarize'),
        value: 'memory_summarize',
    },
    {
        label: t('aura.processingCosts.processingTypes.tenant_usage_limit'),
        value: 'tenant_usage_limit',
    },
    {
        label: t('aura.processingCosts.processingTypes.provider_rate_limit'),
        value: 'provider_rate_limit',
    },
    {
        label: t('aura.processingCosts.processingTypes.insight_catalog_selection'),
        value: 'insight_catalog_selection',
    },
    {
        label: t('aura.processingCosts.processingTypes.analytical_generation'),
        value: 'analytical_generation',
    },
    {
        label: t('aura.processingCosts.processingTypes.chain_loop_guard'),
        value: 'chain_loop_guard',
    },
    {
        label: t('aura.processingCosts.processingTypes.chain_budget_guard'),
        value: 'chain_budget_guard',
    },
    { label: t('aura.processingCosts.processingTypes.llm_invoke'), value: 'llm_invoke' },
]);
const statusOptions = computed(() => [
    { label: t('aura.processingCosts.statuses.completed'), value: 'completed' },
    { label: t('aura.processingCosts.statuses.failed'), value: 'failed' },
    { label: t('aura.processingCosts.statuses.skipped'), value: 'skipped' },
    { label: t('aura.processingCosts.statuses.pending'), value: 'pending' },
    { label: t('aura.processingCosts.statuses.processing'), value: 'processing' },
]);

const update = (changes: AuraProcessingCostsFilters) =>
    emit('update:modelValue', { ...props.modelValue, ...changes, page: 1 });

const clearFilters = () =>
    update({ userId: undefined, processingType: undefined, status: undefined });

const __returned__ = { props, emit, t, filtersOpened, typeOptions, statusOptions, update, clearFilters, get FilterIcon() { return FilterIcon }, get UiButton() { return UiButton }, get UiMultiselect() { return UiMultiselect }, get UiRightPanel() { return UiRightPanel } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})